"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const jdenticon_1 = __importDefault(require("jdenticon"));
function default_1(random, options = {}) {
    jdenticon_1.default.config = {
        hues: options.hues,
        lightness: {
            color: options.colorLightness,
            grayscale: options.grayscaleLightness
        },
        saturation: {
            color: options.colorSaturation,
            grayscale: options.grayscaleSaturation
        }
    };
    return jdenticon_1.default
        .toSvg(random.seed, 50, 0)
        .replace('width="50"', '')
        .replace('height="50"', '');
}
exports.default = default_1;
//# sourceMappingURL=index.js.map